<div class="rating-bar">
    <img *ngFor="let emojiImagePath of emojiImagePaths; let i = index" [id]="'emoji-img-' + i" (click)="onEmojiImageClick(emojiImagePath,  'emoji-img-' + i)" class="emoji-image" [src]="emojiImagePath">
    
  </div>
  